<template>
    <div class="time-select-popper-item">
        <div class="time-select-popper-item__name">
            {{ value.name }}
        </div>
        <div class="time-select-popper-item__data overflowtext">
            <template v-if="value.detail.weekdays.length">
                <span
                    v-for="(item, index) in value.detail.weekdays"
                    :key="index + 'weekdays'"
                    :class="{ isInline: value.detail.expand }"
                >
                    {{ item }}
                </span>
            </template>
            <template v-if="value.detail.daytime.length">
                <span
                    v-for="(item, index) in value.detail.daytime"
                    :key="index + 'daytime'"
                    :class="{ isInline: value.detail.expand }"
                >{{ item }}
                </span>
            </template>
            <v-tip
                ref="weekDetailTip"
                clazz="time-select-popper-detail-tip"
                placement="top"
                kind="large"
            >
                <template v-if="value.detail.weekdays.length">
                    <p class="text_userDefined">
                        常规生效周期
                    </p>
                    <span
                        v-for="(item, index) in value.detail.weekdays"
                        :key="index + 'weekdays'"
                        class="text_userDefinedspan"
                        :class="{ isInline: value.detail.expand }"
                    >
                        {{ item }}
                    </span>
                </template>
                <template v-if="value.detail.daytime.length">
                    <p
                        class="text_userDefined"
                        :class="{ text_userDefined1: value.detail.weekdays.length }"
                    >
                        特殊生效日期
                    </p>
                    <span
                        v-for="(item, index) in value.detail.daytime"
                        :key="index + 'daytime'"
                        class="text_userDefinedspan"
                        :class="{ isInline: value.detail.expand }"
                    >{{ item }}
                    </span>
                </template>
            </v-tip>
        </div>
        <a
            v-tip:weekDetailTip.hover.delay
            class="time-select-popper-item__more"
            href="javascript:;"
        >查看全部</a>
    </div>
</template>

<script>
export default {
  name: 'TimeSelectPopperItem',

  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  created() {},
  methods: {},
};
</script>
<style lang="less">
@import './style.less';
</style>
